











import { Vue, Component } from 'vue-property-decorator';
import { routeNames } from '@/utils/router';
import { ComponentOptions } from 'vue/types/options';
import { RootState } from '@/store';
import { State } from 'vuex-class';
import { navigationQueryName } from '@/utils';
import { DataListItem } from '@/types';

@Component({
  name: 'CopyRegisterIdButton',
  components: {
    MyButton: () => import('@/components/my-button.vue'),
  },
  routeNames: routeNames
} as ComponentOptions<Vue>)
export default class extends Vue {

  @State((state: RootState) => state.dataManagement.currentRegisterId)
  private currentRegisterId!: DataListItem['id'];

  @State((state: RootState) => state.dataManagement.enableCopyLinkButton)
  private enableCopyLinkButton!: boolean;

  private checkIcoVisible: boolean = false;
  private checkIcoTimeout!: ReturnType<Window['setTimeout']> & number;

  private sendNavigationQueryMessage(): void {
    this.checkIcoVisible = true;
    window.parent.postMessage({[navigationQueryName]: `?${navigationQueryName}=${this.currentRegisterId}`}, '*');
    clearTimeout(this.checkIcoTimeout);
    this.checkIcoTimeout = setTimeout(() => this.checkIcoVisible = false, 1000);
  }
}
